module.exports = "<svg id=\"88f89e64-2ffc-430a-b413-1f9bd882be7c\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 30\"><title>arrow</title><polygon points=\"46.13 14 0 14 0 16 46.13 16 30.95 30 33.81 30 50 15 33.81 0 30.95 0 46.13 14\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-01.svg
// module id = 497
// module chunks = 1